export const MODULE_PATH = "administration";

export const TASKS = `/s/${MODULE_PATH}/home`;
export const ISSUES = `/s/${MODULE_PATH}/issues`;
export const ISSUES_DETAIL = `/s/${MODULE_PATH}/issues/issues`;

export const DAMAGES_PICKER = `/s/${MODULE_PATH}/damages`;
export const PENALIZATIONS_PICKER = `/s/${MODULE_PATH}/penalizations`;
export const RESERVE_REDUCTIONS_PICKER = `/s/${MODULE_PATH}/reserveReductions`;
export const USERS_PICKER = `/s/${MODULE_PATH}/users`;

export const USERS_VALIDATION = `/s/${MODULE_PATH}/users/validation`;
export const DAMAGES_VALIDATION = `/s/${MODULE_PATH}/damages/validation`;
export const PENALIZATIONS_VALIDATION = `/s/${MODULE_PATH}/penalizations/validation`;
export const RESERVE_REDUCTIONS_VALIDATION = `/s/${MODULE_PATH}/reserveReductions/validation`;
